import { useState } from 'react';
import { useAttachmentDecisions } from '@/hooks/queries/useChainDecisions';
import { AttachmentDecisionModal } from './AttachmentDecisionModal';

export function AttachmentDecisionBanner() {
  const { data: decisions = [] } = useAttachmentDecisions();
  const [openDecisionId, setOpenDecisionId] = useState<string | null>(null);

  if (!decisions || decisions.length === 0) return null;

  const openDecision = openDecisionId ? decisions.find(d => d.id === openDecisionId) : null;

  return (
    <>
      <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2 text-sm flex items-center justify-between">
        <span className="text-yellow-900">
          {decisions.length} recent order{decisions.length > 1 ? 's' : ''} may belong to an existing chain.
        </span>
        <button
          className="text-blue-700 underline hover:text-blue-900"
          onClick={() => setOpenDecisionId(decisions[0].id)}
        >
          Review →
        </button>
      </div>
      {openDecision && (
        <AttachmentDecisionModal
          decision={openDecision}
          onClose={() => setOpenDecisionId(null)}
        />
      )}
    </>
  );
}
